<template>
  <div class="left_block content-create">
    <p class="header">
      <router-link :to="'/all-courses'">
        <span class="link"> Все курсы <i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>

      <router-link :to="'/all-courses/create/' + stageInfo.course_id">
        <span class="link"> Конструктор курса <i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>

      Добавление контента
    </p>

    <TestLessonItem
      :fields-changed="fieldsChanged"
      @delete="deleteStage"
      @save="saveStage"
      :element="stageInfo"
      :item="item"
      :current-author="currentAuthor"
    />

    <b-upload drag-drop v-model="excelFile" @input="fileUploaded" class="xcel-button" v-if="stageInfo.type !== 1">
      <p>Загрузить заготовленные вопросы</p>
    </b-upload>

    <!-- <button @click="addQuestionsFromFile" v-if="stageInfo.type !== 1">Загрузить заготовленные вопросы</button> -->

    <div class="main_content lesson_content" v-if="stageInfo.type === 1">
      <p class="content_header">Основной материал данного урока</p>
      <LectionContent :stage-info="stageInfo" @saveStage="saveStage" />
    </div>

    <div class="main_content test_content" v-if="stageInfo.type === 2">
      <div>
        <p class="content_header">Список вопросов</p>
        <draggable
          handle=".mdi-drag-vertical"
          v-model="questionsList"
          @start="drag = true"
          @end="drag = false"
          class="questions_list"
          v-bind="dragOptions"
        >
          <TestContent
            :fields-changed="fieldsChanged"
            :stages-list="stagesList"
            @delete-question="deleteQuestion"
            @save="saveStage"
            v-for="(question, i) in questionsList"
            :key="i"
            :question="question"
            :index="i"
          />
        </draggable>
        <div class="add-question" @click="addQuestion()">
          <div class="plus-icon">
            <i class="mdi mdi-plus"></i>
          </div>
          <span>Добавить вопрос</span>
        </div>
      </div>
    </div>

    <div class="main_content test_content" v-if="stageInfo.type === 3">
      <div class="themes_list" v-for="(theme, j) in finalQuestionsList" :key="j">
        <p class="content_header">
          <span>Тема {{ j + 1 }}</span>
          <span class="delete-button" @click="deleteTheme(j)">
            <i class="mdi mdi-file-document-box-remove-outline"></i> Удалить
          </span>
        </p>
        <draggable
          handle=".mdi-drag-vertical"
          :list="theme"
          @start="drag = true"
          @end="drag = false"
          class="questions_list"
          v-bind="dragOptions"
        >
          <TestContent
            :fields-changed="fieldsChanged"
            :stages-list="stagesList"
            @delete-question="deleteFinalQuestion"
            @save="saveStage"
            v-for="(question, i) in theme"
            :key="i"
            :question="question"
            :index="i"
            :theme-index="j"
          />
        </draggable>
        <div class="add-question" @click="addQuestion(j)">
          <div class="plus-icon">
            <i class="mdi mdi-plus"></i>
          </div>
          <span>Добавить вопрос</span>
        </div>
      </div>
      <div class="add-question" @click="addTheme()">
        <div class="plus-icon">
          <i class="mdi mdi-plus"></i>
        </div>
        <span>Добавить тему</span>
      </div>
    </div>

    <!-- <div class="lesson_description">
      <p class="content_header">Описание урока</p>
      <DescriptionContent
        :loader="loader"
        :fields-changed="fieldsChanged"
        :questions-list="questionsList"
        :final-questions-list="finalQuestionsList"
        :stage-info="stageInfo"
      />
    </div> -->

    <b-modal :active.sync="isLeaveModalOpen" has-modal-card scroll="keep">
      <LeaveModal />
    </b-modal>

    <b-loading :canCancel="true" :is-full-page="true" :active="loader.isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import TestLessonItem from '@/components/admin/all-courses/content/TestPlanItem'
import TestContent from '@/components/admin/all-courses/content/TestContent'
import LectionContent from '@/components/admin/all-courses/content/LectionContent'
// import DescriptionContent from '@/components/admin/all-courses/content/DescriptionContent'
import LeaveModal from '@/components/modal/LeaveModal'
import { toastInfo, toastDanger } from '@/lib/toastCfg'
import XLSX from 'xlsx'

export default {
  components: {
    TestContent,
    TestLessonItem,
    LeaveModal,
    LectionContent,
    // DescriptionContent,
    draggable
  },
  data() {
    return {
      isLeaveModalOpen: false,
      item: {
        text: 'Сохранить изменения',
        disabled: false,
        action: 'save'
      },
      isValid: false,
      questionsList: [this.defaultQuestion()],
      finalQuestionsList: [[this.defaultQuestion()]],
      fieldsChanged: {
        name: false,
        leaveAllowed: true
      },
      drag: false,
      loader: {
        isLoading: true
      },
      currentAuthor: '',
      excelFile: null
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
    stageInfo() {
      return this.$store.state.stage.stageInfo
    },
    stagesList() {
      return this.$store.state.courses.stagesList
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: window.innerWidth <= 500,
        // disabled: true,
        ghostClass: 'ghost'
      }
    },
    stageId() {
      return Number(this.$route.params.id)
    },
    courseId() {
      return Number(this.$route.query.courseId)
    }
  },
  mounted() {
    this.loadStage().then(() => {
      if (this.userRole === 'methodist') return
      this.loadAuthor()
    })
    this.loadStages()
    window.onbeforeunload = function () {
      return 'Вы собираетесь покинуть страницу? Возможно, внесенные изменения не сохранятся!'
    }
  },
  beforeDestroy() {
    window.onbeforeunload = ''
  },
  beforeRouteLeave(to, from, next) {
    if (!this.fieldsChanged.leaveAllowed) {
      this.isLeaveModalOpen = true
      this.$nextTick(() => {
        document.getElementById('confirm-leave-btn').addEventListener('click', () => {
          this.isLeaveModalOpen = false
          next()
        })
        document.getElementById('abort-leave-btn').addEventListener('click', () => {
          this.isLeaveModalOpen = false
          next(false)
        })
      })
    } else {
      next()
    }
  },
  methods: {
    defaultQuestion() {
      return {
        comment: '',
        answerType: 1,
        lessonLink: 0,
        lessonLinkType: 0,
        chosenAnswer: '',
        chosenAnswers: [],
        title: '',
        open: false,
        preview: '',
        answersList: [
          {
            text: '',
            correct: false,
            correctAnswer: '',
            correctIndex: 0,
            correctID: 0
          }
        ],
        columnsList: [
          {
            text: '',
            id: 1
          }
        ]
      }
    },
    loadStageCallback(data) {
      this.loader.isLoading = false
      this.$store.commit('setStageInfo', { list: data })
      let newData = JSON.parse(data.test_material.content)
      newData.forEach((question) => {
        if (!question.columnsList) {
          question.columnsList = [{ text: '', id: 1 }]
        }
      })
      if (data.type === 2) {
        this.questionsList = newData
      } else if (data.type === 3) {
        this.finalQuestionsList = newData
      }
    },
    loadAuthor() {
      this.$axios2
        .get('users/' + this.stageInfo.user_id)
        .then((resp) => {
          this.currentAuthor = resp.data.surname + ' ' + resp.data.name
        })
        .catch(this.$errorToast)
    },
    loadStage() {
      return this.$axios2
        .get('courses/' + this.courseId + '/stages/' + this.stageId)
        .then((resp) => {
          this.loadStageCallback(resp.data)
        })
        .catch((err) => {
          this.loader.isLoading = false
          this.$errorToast(err)
        })
    },
    loadStages() {
      this.$axios2
        .get('courses/' + this.courseId + '/stages')
        .then((resp) => {
          this.$store.commit('setStagesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    deleteQuestion({ index }) {
      this.fieldsChanged.leaveAllowed = false
      this.questionsList.splice(index, 1)
    },
    deleteFinalQuestion({ index, themeIndex }) {
      this.fieldsChanged.leaveAllowed = false
      this.finalQuestionsList[themeIndex].splice(index, 1)
    },
    deleteStage() {
      this.fieldsChanged.leaveAllowed = true
      this.$axios2
        .delete('courses/' + this.courseId + '/stage/' + this.stageId)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.$router.push('/all-courses/create/' + this.stageInfo.course_id)
        })
        .catch(this.$errorToast)
    },
    sendRequest(data) {
      this.loader.isLoading = true
      this.$axios2
        .post('courses/' + this.courseId + '/stages/' + this.stageId, data)
        .then((resp) => {
          this.$buefy.toast.open(toastInfo())
          this.loadStageCallback(resp.data)
        })
        .catch((err) => {
          this.$errorToast(err)
          this.loader.isLoading = false
        })
      this.fieldsChanged.leaveAllowed = true
    },
    saveStage() {
      if (this.stageInfo.type === 2) {
        this.saveLearningTest()
      } else if (this.stageInfo.type === 3) {
        this.saveFinalTest()
      } else {
        this.saveLesson()
      }
    },
    saveLearningTest() {
      let newStage = {
        sort_number: this.stageInfo.sort_number,
        description: this.stageInfo.description,
        type: this.stageInfo.type,
        test_material: {
          attempt_count: this.stageInfo.test_material.attempt_count,
          percent: this.stageInfo.test_material.percent,
          question_count: this.questionsList.length,
          duration: 0
        },
        lesson_links: []
      }

      this.questionsList.forEach((question, qindex) => {
        question['id'] = String(qindex)
        question.answersList.forEach((answer, aindex) => {
          answer['id'] = String(qindex) + String(aindex)
          if (question.answerType === 3) {
            answer.correct = true
          } else if (question.answerType === 4 || question.answerType === 5) {
            answer.correct = true
            answer.correctIndex = aindex
          }
        })
        if (Number(question.lessonLinkType) === 0) {
          newStage.lesson_links.push(question.lessonLink)
        }
      })

      newStage.test_material['content'] = JSON.stringify(this.questionsList)

      if (!newStage.test_material.percent || newStage.test_material.percent === 0) {
        this.$buefy.toast.open(toastDanger('Порог прохождения - обязательное поле'))
        return
      }

      if (newStage.test_material.percent > 100) {
        this.$buefy.toast.open(toastDanger('Порог прохождения не может быть больше 100%'))
        return
      }

      if (this.questionsList.length) {
        for (let i = 0; i < this.questionsList.length; i++) {
          if (!this.questionsList[i].lessonLink || this.questionsList[i].lessonLink === 0) {
            this.$buefy.toast.open(toastDanger('Вы не выбрали ссылку к вопросу (вопрос ' + (i + 1) + ')'))
            this.isValid = false
            return
          }
          if (
            this.questionsList[i].lessonLinkType === 1 &&
            !this.questionsList[i].lessonLink.includes('http://') &&
            !this.questionsList[i].lessonLink.includes('https://')
          ) {
            this.$buefy.toast.open(
              toastDanger('Введите корректную ссылку к вопросу (вопрос ' + (i + 1) + '); Пример: https://website.com')
            )
            this.isValid = false
            return
          }
          if (!this.questionsList[i].title.replace(/ /g, '').length) {
            this.$buefy.toast.open(toastDanger('Вы не ввели текст вопроса (вопрос ' + (i + 1) + ')'))
            this.isValid = false
            return
          }
          if (this.questionsList[i].columnsList.length < 2 && this.questionsList[i].answerType === 7) {
            this.$buefy.toast.open(toastDanger('В вопросе должно быть больше одной таблицы (вопрос ' + (i + 1) + ')'))
            this.isValid = false
            return
          }
          if (
            this.questionsList[i].answersList.length < 2 &&
            this.questionsList[i].answerType != 3 &&
            this.questionsList[i].answerType != 7 &&
            this.questionsList[i].answerType != 6
          ) {
            this.$buefy.toast.open(
              toastDanger('В вопросе должно быть больше одного варианта ответа (вопрос ' + (i + 1) + ')')
            )
            this.isValid = false
            return
          }
          for (let j = 0; j < this.questionsList[i].columnsList.length; j++) {
            if (this.questionsList[i].answerType !== 7) {
              continue
            }
            if (!this.questionsList[i].columnsList[j].text.replace(/ /g, '').length) {
              this.$buefy.toast.open(
                toastDanger('Вы не ввели название таблицы (вопрос ' + (i + 1) + ', таблица ' + (j + 1) + ')')
              )
              this.isValid = false
              return
            }
          }
          for (let j = 0; j < this.questionsList[i].answersList.length; j++) {
            if (this.questionsList[i].answerType === 5) {
              if (
                !this.questionsList[i].answersList[j].text2 ||
                (this.questionsList[i].answersList[j].text2 &&
                  !this.questionsList[i].answersList[j].text2.replace(/ /g, '').length)
              ) {
                this.$buefy.toast.open(
                  toastDanger('Вы не ввели текст ответа (вопрос ' + (i + 1) + ', ответ ' + (j + 1) + ')')
                )
                this.isValid = false
                return
              }
            }
            if (!this.questionsList[i].answersList[j].text.replace(/ /g, '').length) {
              this.$buefy.toast.open(
                toastDanger('Вы не ввели текст ответа (вопрос ' + (i + 1) + ', ответ ' + (j + 1) + ')')
              )
              this.isValid = false
              return
            }
          }
          if (
            this.questionsList[i].answersList.some((answer) => {
              return answer.correct === true
            })
          ) {
            this.isValid = true
          } else {
            this.$buefy.toast.open(
              toastDanger(
                this.questionsList[i].answerType === 1
                  ? 'В вопросе должен быть один правильный ответ (вопрос ' + (i + 1) + ')'
                  : 'В вопросе должен быть хотя бы один правильный ответ (вопрос ' + (i + 1) + ')'
              )
            )
            this.isValid = false
            return
          }
        }
      } else {
        this.$buefy.toast.open(toastDanger('Добавьте вопрос'))
      }

      if (this.isValid) {
        this.sendRequest(newStage)
      }
    },
    saveFinalTest() {
      let newFinalStage = {
        sort_number: this.stageInfo.sort_number,
        description: this.stageInfo.description,
        type: this.stageInfo.type,
        test_material: {
          questions_per_theme: Number(this.stageInfo.test_material.questions_per_theme),
          percent: this.stageInfo.test_material.percent,
          question_count: 0,
          duration: this.stageInfo.test_material.duration
        },
        lesson_links: []
      }

      this.finalQuestionsList.forEach((theme, tindex) => {
        theme.forEach((question, qindex) => {
          newFinalStage.test_material.question_count += 1
          question['id'] = String(tindex) + String(qindex)
          question.answersList.forEach((answer, aindex) => {
            answer['id'] = String(tindex) + String(qindex) + String(aindex)
            if (question.answerType === 3) {
              answer.correct = true
            } else if (question.answerType === 4 || question.answerType === 5) {
              answer.correct = true
              answer.correctIndex = aindex
            }
          })
          if (Number(question.lessonLinkType) === 0) {
            newFinalStage.lesson_links.push(question.lessonLink)
          }
        })
      })

      newFinalStage.test_material['content'] = JSON.stringify(this.finalQuestionsList)

      if (!newFinalStage.test_material.questions_per_theme) {
        this.$buefy.toast.open(toastDanger('Кол-во вопросов из тем - обязательное поле'))
        return
      }

      if (!newFinalStage.test_material.duration) {
        this.$buefy.toast.open(toastDanger('Длительность теста - обязательное поле'))
        return
      }

      if (this.finalQuestionsList.length) {
        for (let t = 0; t < this.finalQuestionsList.length; t++) {
          if (this.finalQuestionsList[t].length) {
            for (let q = 0; q < this.finalQuestionsList[t].length; q++) {
              if (!this.finalQuestionsList[t][q].lessonLink || this.finalQuestionsList[t][q].lessonLink === 0) {
                this.$buefy.toast.open(
                  toastDanger('Вы не выбрали ссылку к вопросу (тема ' + (t + 1) + ', вопрос ' + (q + 1) + ')')
                )
                this.isValid = false
                return
              }
              if (
                this.finalQuestionsList[t][q].lessonLinkType === 1 &&
                !this.finalQuestionsList[t][q].lessonLink.includes('http://') &&
                !this.finalQuestionsList[t][q].lessonLink.includes('https://')
              ) {
                this.$buefy.toast.open(
                  toastDanger(
                    'Введите корректную ссылку к вопросу (тема ' +
                      (t + 1) +
                      ', вопрос ' +
                      (q + 1) +
                      '); Пример: https://website.com'
                  )
                )
                this.isValid = false
                return
              }
              if (!this.finalQuestionsList[t][q].title.replace(/ /g, '').length) {
                this.$buefy.toast.open(
                  toastDanger('Вы не ввели текст вопроса (тема ' + (t + 1) + ', вопрос ' + (q + 1) + ')')
                )
                this.isValid = false
                return
              }
              if (
                this.finalQuestionsList[t][q].answersList.length < 2 &&
                this.finalQuestionsList[t][q].answerType != 3 &&
                this.finalQuestionsList[t][q].answerType != 7 &&
                this.finalQuestionsList[t][q].answerType != 6
              ) {
                this.$buefy.toast.open(
                  toastDanger(
                    'В вопросе должно быть больше одного варианта ответа (тема ' + (t + 1) + ', вопрос ' + (q + 1) + ')'
                  )
                )
                this.isValid = false
                return
              } else {
                for (let a = 0; a < this.finalQuestionsList[t][q].answersList.length; a++) {
                  if (this.finalQuestionsList[t][q].answerType === 5) {
                    if (
                      !this.finalQuestionsList[t][q].answersList[a].text2 &&
                      !this.finalQuestionsList[t][q].answersList[a].text2.replace(/ /g, '').length
                    ) {
                      this.$buefy.toast.open(
                        toastDanger('Вы не ввели текст ответа (вопрос ' + (q + 1) + ', ответ ' + (a + 1) + ')')
                      )
                      this.isValid = false
                      return
                    }
                  }
                  if (!this.finalQuestionsList[t][q].answersList[a].text.replace(/ /g, '').length) {
                    this.$buefy.toast.open(
                      toastDanger(
                        'Вы не ввели текст ответа (тема ' + (t + 1) + ', вопрос ' + (q + 1) + ', ответ ' + (a + 1) + ')'
                      )
                    )
                    this.isValid = false
                    return
                  }
                }
                if (
                  this.finalQuestionsList[t][q].answersList.some((answer) => {
                    return answer.correct === true
                  })
                ) {
                  this.isValid = true
                } else {
                  this.$buefy.toast.open(
                    toastDanger(
                      this.finalQuestionsList[t][q].answerType === 1
                        ? 'В вопросе должен быть один правильный ответ (тема ' + (t + 1) + ', вопрос ' + (q + 1) + ')'
                        : 'В вопросе должен быть хотя бы один правильный ответ (тема ' +
                            (t + 1) +
                            ', вопрос ' +
                            (q + 1) +
                            ')'
                    )
                  )
                  this.isValid = false
                  return
                }
              }
            }
          } else {
            this.$buefy.toast.open(toastDanger('Добавьте вопрос (тема' + (t + 1) + ')'))
          }
        }
      } else {
        this.$buefy.toast.open(toastDanger('Добавьте тему'))
      }

      if (this.isValid) {
        this.sendRequest(newFinalStage)
      }
    },
    saveLesson() {
      if (!this.stageInfo.text_material || !this.stageInfo.text_material.length) {
        this.$buefy.toast.open(toastDanger('Поле с текстом урока не может быть пустым'))
        return
      }
      this.sendRequest({
        sort_number: this.stageInfo.sort_number,
        description: this.stageInfo.description,
        duration: this.stageInfo.duration,
        type: this.stageInfo.type,
        text_material: this.stageInfo.text_material
      })
    },
    addQuestion(val) {
      if (val || val === 0) {
        this.fieldsChanged.leaveAllowed = false
        this.finalQuestionsList[val].push(this.defaultQuestion())
        let qindex = this.finalQuestionsList[val].length - 1
        this.finalQuestionsList[val][qindex].answersList[0].id = String(qindex) + '0'
      } else {
        this.fieldsChanged.leaveAllowed = false
        this.questionsList.push(this.defaultQuestion())
        let qindex = this.questionsList.length - 1
        this.questionsList[qindex].answersList[0].id = String(qindex) + '0'
      }
    },
    addTheme() {
      this.fieldsChanged.leaveAllowed = false
      this.finalQuestionsList.push([this.defaultQuestion()])
    },
    deleteTheme(index) {
      this.fieldsChanged.leaveAllowed = false
      this.finalQuestionsList.splice(index, 1)
    },
    fileUploaded(selectedFile) {
      this.loader.isLoading = true
      try {
        var fileReader = new FileReader()
        fileReader.onload = (event) => {
          var data = event.target.result

          var workbook = XLSX.read(data, {
            type: 'binary'
          })
          workbook.SheetNames.forEach((sheet) => {
            let rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet])
            this.addQuestionsFromFile(rowObject)
          })
        }
        fileReader.readAsBinaryString(selectedFile)
      } catch (e) {
        this.loader.isLoading = false
      }
    },
    addQuestionsFromFile(fileQuest) {
      let themes = []
      let questions = []
      // let file = require('@/data/questions/index.js')
      // let fileQuest = file.questions

      fileQuest.forEach((question, i) => {
        if (!question.title) return
        if (fileQuest[i - 1]) {
          if (fileQuest[i - 1].topic_id !== question.topic_id) {
            if (
              themes.every((el) => {
                return el.id !== question.topic_id
              })
            ) {
              themes.push({ id: question.topic_id })
            }
          }
        } else {
          themes.push({ id: question.topic_id })
        }
        let newQuestion = {}
        newQuestion['comment'] = question.comment ? question.comment : ''
        newQuestion['answerType'] = Number(question.answerType)
        newQuestion['id'] = i
        if (question.lessonLink) {
          newQuestion['lessonLink'] = question.lessonLink
          newQuestion['lessonLinkType'] = Number(question.lessonLinkType)
        } else {
          newQuestion['lessonLink'] = 'https://www.google.ru/'
          newQuestion['lessonLinkType'] = 1
        }
        newQuestion['title'] = question.title
        newQuestion['answersList'] = []
        newQuestion['columnsList'] = []
        newQuestion['preview'] = ''
        newQuestion['topic_id'] = question.topic_id
        for (let a = 0; a < Object.keys(question).length; a++) {
          let newAnswer = {}
          let newColumn = {}
          if (question['answers_' + a + '_text']) {
            if (question['answers_' + a + '_text'].includes('***')) {
              newAnswer['text'] = question['answers_' + a + '_text'].replace('***', '')
              newAnswer['correct'] = true
              newAnswer['correctIndex'] = 0
              newAnswer['correctAnswer'] = 'true'
            } else {
              newAnswer['text'] = question['answers_' + a + '_text']
              newAnswer['correct'] = false
              newAnswer['correctIndex'] = 0
              newAnswer['correctAnswer'] = 'false'
            }
            if (question['answers_' + a + '_text_2']) {
              newAnswer['text2'] = question['answers_' + a + '_text_2']
            }
            if (newQuestion['answerType'] === 7) {
              let columnID = Number(question['answers_' + a + '_text'].replace(/\s/g, '').slice(-1))
              if (columnID) {
                newAnswer['correctID'] = columnID
                newAnswer['text'] = newAnswer['text'].slice(0, -4)
              }
            }
            newQuestion['answersList'].push(newAnswer)
          }
          if (question['columns_' + a + '_text']) {
            newColumn['text'] = question['columns_' + a + '_text']
            newColumn['id'] = newQuestion['columnsList'].length + 1
            newQuestion['columnsList'].push(newColumn)
          }
        }
        questions.push(newQuestion)
      })

      themes.forEach((theme, i) => {
        let newTheme = []
        questions.forEach((question) => {
          if (question.topic_id === theme.id) {
            newTheme.push(question)
          }
          question.answersList.forEach((answer, i) => {
            if (answer.correct) {
              question['chosenAnswer'] = 'answer_' + (i + 1)
            }
          })
        })
        themes[i] = newTheme
      })

      this.questionsList = questions
      this.finalQuestionsList = themes

      this.loader.isLoading = false
    }
  }
}
</script>
